import { motion, useReducedMotion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

const ScrollAnimation = ({ children, delay = 0, className = '' }) => {
  const prefersReducedMotion = useReducedMotion()
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
    rootMargin: '-40px 0px',
  })
  const hidden = prefersReducedMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={hidden}
      animate={inView || prefersReducedMotion ? { opacity: 1, y: 0 } : hidden}
      transition={{
        duration: prefersReducedMotion ? 0 : 0.6,
        delay: prefersReducedMotion ? 0 : delay,
        ease: 'easeOut',
      }}
    >
      {children}
    </motion.div>
  )
}

export default ScrollAnimation
